import { html } from 'lit-html'

export default async function registrations (state, appOptions) {
  await import(/* webpackChunkName: 'pollev-registrations' */ '../../participant-components/registrations')

  return html`<pec-participant-registrations></pec-participant-registrations>`
}
